<template>
  <div id="app">
    <!-- 回到顶部 -->
    <el-backtop :bottom="60" style="color: #8b5cf6;"></el-backtop>
    <!-- 路由 -->
    <router-view/>
    <GlobalApplyDialog />
  </div>
</template>

<script>
import GlobalApplyDialog from '@/components/GlobalApplyDialog.vue';

export default {
  name: 'App',
  components: {
    GlobalApplyDialog
  }
};
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: #ffffff;
}

#app {
  font-family: "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-x: hidden;
  max-width: 100%;
}

</style>
